import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@shadcn/components/ui/dialog';
import { Button } from '@shadcn/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shadcn/components/ui/select';
import { Label } from '@shadcn/components/ui/label';
import { Input } from '@shadcn/components/ui/input';
import { addOrderSourceToRegion } from '../RegionConfig.service';

export function AddOrderSourceDialog({ open, onOpenChange, regionId, onSuccess }) {
  const [formData, setFormData] = useState({
    customId: '',
    name: '',
    type: 'online',
    status: 'Active'
  });
  const [isLoading, setIsLoading] = useState(false);

  // Reset form when dialog opens
  useEffect(() => {
    if (open) {
      setFormData({
        customId: '',
        name: '',
        type: 'online',
        status: 'Active'
      });
    }
  }, [open]);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const data = {
        id: formData.customId,
        name: formData.name,
        type: formData.type,
        status: formData.status
      };

      const newSource = await addOrderSourceToRegion(regionId, data);
      onSuccess(newSource);
      onOpenChange(false);
    } catch (error) {
      console.error('Failed to add order source:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Add Online Order Source</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="customId">
                Order Source ID
              </Label>
              <Input
                id="customId"
                value={formData.customId}
                onChange={(e) => handleChange('customId', e.target.value)}
                className="w-full"
                placeholder="Example: shopify_au"
                required
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="name">
                Display Name
              </Label>
              <Input
                id="name"
                value={formData.name}
                onChange={(e) => handleChange('name', e.target.value)}
                className="w-full"
                placeholder="Enter display name"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="status">
                Status
              </Label>
              <Select
                value={formData.status}
                onValueChange={(value) => handleChange('status', value)}
              >
                <SelectTrigger className="w-full">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Active">Active</SelectItem>
                  <SelectItem value="Inactive">Inactive</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <DialogFooter>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? 'Saving...' : 'Save'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
} 
